/* !
 * press.js v1.0.0
 * Copyright, Connecty Inc.
 */
const a = 'is-active';
const v = 'is-visible';

// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

const pressFUNCTIONS = () => {

};

document.addEventListener('DOMContentLoaded', () => {
	if (window.FUNCTIONS?.localDecision()) {
		document.addEventListener('localincludeLoaded', () => { pressFUNCTIONS(); });
	} else {
		pressFUNCTIONS();
	}
});
